import {
    useCallback,
} from 'react'
import useSimpleApiRequest from 'app/hooks/useSimpleApiRequest'

import useFilter from 'app/hooks/useFilter'
import {
    AsyncMutationOptions,
} from 'app/types/request.types'

import requests from 'app/requests/Lane/Lane.requests'
import AccountLaneSpreadsheet from '../AccountLaneSpreadsheet'

import {
    LaneBulkCreatePayload,
} from '../AccountLanes.types'

const AccountLaneBulkCreate = ({
    onClose,
}: {
    onClose: () => void
}) => {
    const filterOptions = useFilter()

    const {
        mutateAsync: create,
    } = useSimpleApiRequest<LaneBulkCreatePayload>({
        title: 'New lanes were created',
        name: 'AccountLanesBulkCreate',
        requestParams: requests.bulkCreate(),
        onSuccess: () => {
            filterOptions.setDefaultData()
        },
    })

    const handleSave = useCallback(async (
        values: LaneBulkCreatePayload,
        options?: AsyncMutationOptions,
    ) => {
        await create(values, {
            ...options,
            onSuccess: options?.onSuccess || onClose,
        })
    }, [
        create,
        onClose,
    ])

    return (
        <AccountLaneSpreadsheet
            filterOptions={filterOptions}
            onSave={handleSave}
            onCancel={onClose}
        />
    )
}

export default AccountLaneBulkCreate
